<template>
  <div name="register_edit" class="inner">
    <innertopbar @close="closeWindow()">
      <template v-slot:breadcrumb>
        <router-link to="/toolbox/pupils"> Pupils </router-link>
        <i class="carret fas fa-caret-right"></i> {{ title }}
      </template>

      <template v-slot:listitems>
        <li
          v-if="!newAddition"
          @click="archive"
          v-tooltip="{
            content: 'Archive Pupil',
            placement: 'bottom-center',
            offset: 5,
            classes: ['tooltip-info'],
          }"
          title="Archive Pupil"
          class="action-list-item inline-block hover:opacity-100"
        >
          <i class="fas fa-archive pt-4" title="Archive Pupil"></i>
        </li>
        <li
          v-if="!newAddition"
          @click="deletion"
          v-tooltip="{
            content: 'Delete Pupil',
            placement: 'bottom-center',
            offset: 5,
            classes: ['tooltip-info'],
          }"
          title="Delete Pupil"
          class="action-list-item inline-block hover:opacity-100"
        >
          <i class="icon fas fa-trash-alt pt-4" title="Delete Pupil"></i>
        </li>

        <li
          v-if="!newAddition"
          class="inline-block mx-4 text-2xl text-gray-400"
        >
          |
        </li>

        <li class="inline-block">
          <button
            @click="submitForm()"
            type="button"
           class="publish-button hover:opacity-75"
          >
            Publish Changes
          </button>
        </li>
      </template>
    </innertopbar>

    <form v-on:submit.prevent="submitPupil" id="pupilForm" ref="form">
      <div class="w-full mx-auto grid grid grid-flow-col grid-cols-2 gap-20">
        <div class="mt-6 ml-10 p-8 bg-white rounded-lg mb-10">
          <div class="w-95p mx-auto">
            <h2 class="w-full text-xl mb-8 -mx-3 pt-4 font-bold text-gray-700">
              Pupil Information
            </h2>

            <div class="flex flex-wrap -mx-3 mb-8">
              <div class="w-full">
                <label class="form-label" for="grid-title"> Pupil Name </label>
                <input
                  v-model="name"
                  class="mb-2"
                  id="grid-title"
                  type="text"
                  placeholder="Enter pupil name"
                  required
                />
                <p class="text-red-300 text-xs italic">
                  Please fill out this field.
                </p>
              </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-8">
              <div class="w-full">
                <label class="form-label" for="grid-title"> Sex </label>
                <button
                  type="button"
                  class="
                    mr-3
                    mb-2
                    rounded
                    p-2
                    px-6
                    cursor-pointer
                                          hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue

                    font-bold
                    icon
                    fa-male
                  "
                  v-bind:class="[
                    'male' == gender
                      ? 'bg-action-blue bg-opacity-75 text-white'
                      : 'bg-gray-200 text-gray-600',
                  ]"
                  @click="gender = 'male'"
                >
                  Male
                </button>

                <button
                  type="button"
                  class="
                    mr-3
                    mb-2
                    rounded
                    p-2
                    px-6
                    cursor-pointer
                                         hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue

                    font-bold
                    icon
                    fa-female
                  "
                  v-bind:class="[
                    'female' == gender
                      ? 'bg-action-blue bg-opacity-75 text-white'
                      : 'bg-gray-200 text-gray-600',
                  ]"
                  @click="gender = 'female'"
                >
                  Female
                </button>
                <p class="text-red-300 text-xs mt-1 italic">
                  Please fill out this field.
                </p>
              </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-4">
              <div class="w-full">
                <label class="form-label" for="grid-ethnicity">
                  Ethnicity
                </label>
                <input
                  v-model="ethnicity"
                  class="mb-2"
                  id="grid-ethnicity"
                  type="text"
                  placeholder="Ethnicity"
                />
              </div>
            </div>
            <div class="flex flex-wrap -mx-3 mb-6">
              <div class="w-full">
                <label class="form-label" for="grid-sen"> SEN </label>
                <input
                  v-model="sen"
                  class="mb-2"
                  id="grid-sen"
                  type="text"
                  placeholder="SEN"
                />
              </div>
            </div>
            <div class="flex flex-wrap -mx-3 mb-4">
              <div class="w-full">
          
          <div class="font-semibold flex justify-between w-ful pb-4 text-gray-600">
            <label class="form-label" for="grid-sen"> Tags </label>
                    <div class="flex"> 
                      <div class="bg-blue-500 tag-example mr-2 w-10"
                      @click="addTags('sen')">#sen</div>

                      <div class="bg-orange-500  mr-2  tag-example"
                      @click="addTags('ofsted')">#ofsted</div>
                      <div
                        class="mr-2 tag-example"
                        style="background-color: #ef6c00;"
                        @click="addTags('bronze')"
                      >
                        #bronze
                      </div>

                      <div
                        class="mr-2 tag-example w-12"
                         style="background-color: #616161;"
                        @click="addTags('silver')"
                      >
                        #silver
                      </div>

                      <div
                        class="mr-2 tag-example w-10"
                                  style="background-color: #fdd835;"
                        @click="addTags('gold')"
                      >
                        #gold
                      </div>

                      <div
                        class="bg-red-500 mr-2 tag-example w-10"
                        @click="addTags('20percent')"
                      >
                        #20%
                      </div>
                    </div>
                    
                  </div>
                  <input
                v-model="tags"
                class="pl-2"
                type="text"
                placeholder="Enter tags..."
              />
        </div>
      </div>
          </div>
        </div>

        <div class="p-6 px-8 bg-white h-full">
          <div class="w-95p mx-auto">
            <savenotice
              :title="'Pupil'"
              ref="saveNotice"
              class="right"
            ></savenotice>

            <h2
              class="
                w-full
                text-xl
                mt-8
                mb-8
                -mx-3
                pt-4
                font-bold
                text-gray-700
              "
            >
              School Settings
            </h2>

            <div class="flex flex-wrap -mx-3 mb-8">
              <div class="w-full">
                <label class="form-label" for="grid-space"> Year Group </label>
                <div class="grid-cols-8">
                  <button
                    v-for="item in orderedYears"
                    :key="item.id"
                    type="button"
                    @click="yearId = item.id"
                    v-bind:class="
                      item.id == yearId
                        ? 'bg-action-blue bg-opacity-75 text-white'
                        : 'bg-gray-200 text-gray-600'
                    "
                    class="
                      mr-3
                      mb-2
                      rounded
                      p-2
                      px-6
                      cursor-pointer
                      hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue
                    "
                  >
                    <i
                      class="fas"
                      v-bind:class="
                        yearId == item.id
                          ? 'fa-check-circle'
                          : 'fa-dot-circle'
                      "
                    ></i>
                    {{ item.name }}
                  </button>
                </div>
              </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-6">
              <div class="w-full md:w-1/2 pr-3 mb-6 md:mb-0">
                <label class="form-label" for="grid-class"> Class </label>
                <ClassDropdown
            :classSelected="selectedClass"
            :presetNameOnly="presetClassName"
            @classValueChanged="classSelect"
          ></ClassDropdown>
    
              </div>

              <div class="w-full md:w-1/2 pl-3">
                <div class="w-full">
                  <label class="form-label" for="grid-class-other">
                    OR New Class
                  </label>
                  <input
                    v-model="classNew"
                    class="mb-2"
                    id="grid-sen"
                    type="text"
                    placeholder="New class..."
                  />
                </div>
              </div>

              <p class="text-red-300 mt-1 text-xs italic">
                Please fill out this field.
              </p>
            </div>

            <div class="flex flex-wrap -mx-3 mb-8">
              <div class="w-1/2">
                <label class="form-label" for="grid-title">
                  Pupil Premium
                </label>
                <button
                  type="button"
                  class="
                    mr-3
                    mb-2
                    rounded
                    p-2
                    px-6
                    cursor-pointer
                    hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue
                  "
                  v-bind:class="[
                    hasPupilPremium
                      ? 'bg-action-blue bg-opacity-75 text-white'
                      : 'bg-gray-200 text-gray-600',
                  ]"
                  @click="hasPupilPremium = true"
                >
                  <i
                    class="fas"
                    v-bind:class="
                      hasPupilPremium ? 'fa-check-circle' : 'fa-dot-circle'
                    "
                  ></i>
                  Yes - On
                </button>

                <button
                  type="button"
                  class="
                    mr-3
                    mb-2
                    rounded
                    p-2
                    px-6
                    cursor-pointer
                    hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue
                  "
                  v-bind:class="[
                    !hasPupilPremium
                      ? 'bg-action-blue bg-opacity-75 text-white'
                      : 'bg-gray-200 text-gray-600',
                  ]"
                  @click="hasPupilPremium = false"
                >
                  <i
                    class="fas"
                    v-bind:class="
                      !hasPupilPremium ? 'fa-check-circle' : 'fa-dot-circle'
                    "
                  ></i>
                  No - Off
                </button>
              </div>
               <div class="w-1/2">
                <label class="form-label" for="grid-title">
                  Has ECHP
                </label>
                <button
                  type="button"
                  class="
                    mr-3
                    mb-2
                    rounded
                    p-2
                    px-6
                    cursor-pointer
                    hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue
                  "
                  v-bind:class="[
                    hasECHP
                      ? 'bg-action-blue bg-opacity-75 text-white'
                      : 'bg-gray-200 text-gray-600',
                  ]"
                  @click="hasECHP = true"
                >
                  <i
                    class="fas"
                    v-bind:class="
                      hasECHP ? 'fa-check-circle' : 'fa-dot-circle'
                    "
                  ></i>
                  Yes - On
                </button>

                <button
                  type="button"
                  class="
                    mr-3
                    mb-2
                    rounded
                    p-2
                    px-6
                    cursor-pointer
                    hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue
                  "
                  v-bind:class="[
                    !hasECHP
                      ? 'bg-action-blue bg-opacity-75 text-white'
                      : 'bg-gray-200 text-gray-600',
                  ]"
                  @click="hasECHP = false"
                >
                  <i
                    class="fas"
                    v-bind:class="
                      !hasECHP ? 'fa-check-circle' : 'fa-dot-circle'
                    "
                  ></i>
                  No - Off
                </button>
              </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-8">
              <div class="w-1/2">
                <label class="form-label" for="grid-title">
                  English as Second Language
                </label>
                <button
                  type="button"
                  class="
                    mr-3
                    mb-2
                    rounded
                    p-2
                    px-6
                    cursor-pointer
                    hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue
                  "
                  v-bind:class="[
                    hasEAL
                      ? 'bg-action-blue bg-opacity-75 text-white'
                      : 'bg-gray-200 text-gray-600',
                  ]"
                  @click="hasEAL = true"
                >
                  <i
                    class="fas"
                    v-bind:class="hasEAL ? 'fa-check-circle' : 'fa-dot-circle'"
                  ></i>
                  Yes - On
                </button>

                <button
                  type="button"
                  class="
                    mr-3
                    mb-2
                    rounded
                    p-2
                    px-6
                    cursor-pointer
                    hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue
                  "
                  v-bind:class="[
                    !hasEAL
                      ? 'bg-action-blue bg-opacity-75 text-white'
                      : 'bg-gray-200 text-gray-600',
                  ]"
                  @click="hasEAL = false"
                >
                  <i
                    class="fas"
                    v-bind:class="!hasEAL ? 'fa-check-circle' : 'fa-dot-circle'"
                  ></i>
                  No - Off
                </button>
              </div>
               <div class="w-1/2">
                <label class="form-label" for="grid-title">
                  Is Vulnerable Pupil
                </label>
                <button
                  type="button"
                  class="
                    mr-3
                    mb-2
                    rounded
                    p-2
                    px-6
                    cursor-pointer
                    hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue
                  "
                  v-bind:class="[
                    isVulnerablePupil
                      ? 'bg-action-blue bg-opacity-75 text-white'
                      : 'bg-gray-200 text-gray-600',
                  ]"
                  @click="isVulnerablePupil = true"
                >
                  <i
                    class="fas"
                    v-bind:class="isVulnerablePupil ? 'fa-check-circle' : 'fa-dot-circle'"
                  ></i>
                  Yes - On
                </button>

                <button
                  type="button"
                  class="
                    mr-3
                    mb-2
                    rounded
                    p-2
                    px-6
                    cursor-pointer
                    hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue
                  "
                  v-bind:class="[
                    !isVulnerablePupil
                      ? 'bg-action-blue bg-opacity-75 text-white'
                      : 'bg-gray-200 text-gray-600',
                  ]"
                  @click="isVulnerablePupil = false"
                >
                  <i
                    class="fas"
                    v-bind:class="!isVulnerablePupil ? 'fa-check-circle' : 'fa-dot-circle'"
                  ></i>
                  No - Off
                </button>
              </div>
            </div>

             <div class="flex flex-wrap -mx-3 mb-8">
              <div class="w-1/2">
                <label class="form-label" for="grid-title">
                  Is Looked After
                </label>
                <button
                  type="button"
                  class="
                    mr-3
                    mb-2
                    rounded
                    p-2
                    px-6
                    cursor-pointer
                    hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue
                  "
                  v-bind:class="[
                    isLookedAfter
                      ? 'bg-action-blue bg-opacity-75 text-white'
                      : 'bg-gray-200 text-gray-600',
                  ]"
                  @click="isLookedAfter = true"
                >
                  <i
                    class="fas"
                    v-bind:class="isLookedAfter ? 'fa-check-circle' : 'fa-dot-circle'"
                  ></i>
                  Yes - On
                </button>

                <button
                  type="button"
                  class="
                    mr-3
                    mb-2
                    rounded
                    p-2
                    px-6
                    cursor-pointer
                    hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue
                  "
                  v-bind:class="[
                    !isLookedAfter
                      ? 'bg-action-blue bg-opacity-75 text-white'
                      : 'bg-gray-200 text-gray-600',
                  ]"
                  @click="isLookedAfter = false"
                >
                  <i
                    class="fas"
                    v-bind:class="!isLookedAfter ? 'fa-check-circle' : 'fa-dot-circle'"
                  ></i>
                  No - Off
                </button>
              </div>
               <div class="w-1/2">
                <label class="form-label" for="grid-title">
                  Is Post Looked After
                </label>
                <button
                  type="button"
                  class="
                    mr-3
                    mb-2
                    rounded
                    p-2
                    px-6
                    cursor-pointer
                    hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue
                  "
                  v-bind:class="[
                    isPostLookedAfter
                      ? 'bg-action-blue bg-opacity-75 text-white'
                      : 'bg-gray-200 text-gray-600',
                  ]"
                  @click="isPostLookedAfter = true"
                >
                  <i
                    class="fas"
                    v-bind:class="isPostLookedAfter ? 'fa-check-circle' : 'fa-dot-circle'"
                  ></i>
                  Yes - On
                </button>

                <button
                  type="button"
                  class="
                    mr-3
                    mb-2
                    rounded
                    p-2
                    px-6
                    cursor-pointer
                    hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue
                  "
                  v-bind:class="[
                    !isPostLookedAfter
                      ? 'bg-action-blue bg-opacity-75 text-white'
                      : 'bg-gray-200 text-gray-600',
                  ]"
                  @click="isPostLookedAfter = false"
                >
                  <i
                    class="fas"
                    v-bind:class="!isPostLookedAfter ? 'fa-check-circle' : 'fa-dot-circle'"
                  ></i>
                  No - Off
                </button>
              </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-8">
              <div class="w-full">
          
          <div class="font-semibold flex justify-between w-ful pb-4 text-gray-600">
            <label class="form-label" for="grid-title">
              Additional Notes 
                </label>
           
          </div>  
     <textarea
            v-model="notes"
            type="text"
            placeholder="Enter notes..."
                  class="p-1"
          ></textarea>
        </div>
      </div>

          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { yearGroupMixin} from "@/mixins/yearGroupMixin.js";
import { SchoolService } from "@/services/school.service";

const innertopbar = () => import("@/components/InnerTopBar.vue");
const savenotice = () => import("@/components/SaveNotice.vue");
const ClassDropdown = () => import("@/components/pupil/ClassDropdown.vue");

export default {
  name: "register_edit",
  mixins: [yearGroupMixin],
  props: {
    newAddition: Boolean,
    pupil: Object,
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    // ...mapGetters({ currentUser: 'currentUser' }),
    isDisabled() {
      if (this.selectedClass.id > 0 && this.name.length > 0) {
        return false;
      } else {
        return true;
      }
    },
    orderedYears() {
     var results = this.years
      return results;
    },
    componentLoaded() {
      return this.users.length > 0;
    },
    title() {
      if (this.newAddition) {
        return "Add new pupil";
      } else {
        return this.name;
      }
    },
    yearname() {
      if (this.newAddition) {
        return "";
      } else {
        return pupilYearGroupDisplay(this.pupil)
      }
    },
  },
  data() {
    return {
      school: this.$store.getters.school,
      errored: false,
      pupilInEdit: true,
      hasPupilPremium: false,
      hasEAL: false,
      selectedClass: {},
      selectedOrg: {},
      types: [],
      sen: "",
      ethnicity: "",
      name: "",
      gender: "male",
      yearId: 1,
      classNew: "",
      notes: "",
      tags: "",
      presetClassName: undefined,
      isLookedAfter: false,
	    isVulnerablePupil: false,
	    isPostLookedAfter: false,
	    hasECHP: false,
    };
  },
  created() {
    if (this.newAddition == false) {
      if (this.pupil == undefined) {
        this.closeWindow();
        return;
      } else {
        this.isLookedAfter = this.pupil.looked_after === false || this.pupil.looked_after === null ? false : true;
        this.isVulnerablePupil = this.pupil.vulnerable_pupil === false || this.pupil.vulnerable_pupil === null ? false : true;
        this.isPostLookedAfter = this.pupil.post_looked_after === false || this.pupil.post_looked_after === null ? false : true;
        this.hasECHP = this.pupil.has_ehcp === false || this.pupil.has_ehcp === null ? false : true;

        this.hasPupilPremium = this.pupil.premium_pupil === 0 || this.pupil.premium_pupil === null ? false : true;
        this.hasEAL =
          this.pupil.english_second === 0 || this.pupil.english_second === null ? false : true;
        this.sen =
          this.pupil.sen_status === undefined
            ? ""
            : this.pupil.sen_status;
        this.ethnicity =
          this.pupil.ethnicity == undefined ? "" : this.pupil.ethnicity;
        this.name = this.pupil.name == undefined ? "" : this.pupil.name;
        this.gender =
          this.pupil.gender == undefined
            ? "male"
            : this.pupil.gender.toLowerCase();
        this.yearId =
          this.pupil.year == undefined ? 1 : this.pupil.year.id;
          this.presetClassName = this.pupil.inclass;
          this.notes = this.pupil.notes === undefined ? "" : this.pupil.notes;

          if (this.pupil.tags != undefined) {
            let tagList = this.pupil.tags.map(function(t) {
            return " #" + t.tag_name
           });
           this.tags = tagList.join(", ")
          }
      }
    }
  },
  mounted() {
  },
  methods: {
    submitForm() {
     if (this.$refs.form.requestSubmit === undefined) {
         this.submitPupil()
      } else {
        this.$refs.form.requestSubmit();
      }
    },
    alertDisplay() {
      this.$swal({
        title: "Please complete all fields",
        text: "You must enter a title and set a class to complete the form.",
        type: "warning",
        showCancelButton: false,
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result === true) {
          this.processPupil();
        }
      });
    },
    submitPupil() {
      if (
        this.name == "" ||
        (this.selectedClass.id === 0 && this.classNew.length === 0)
      ) {
        this.alertDisplay();
      } else {
        this.processPupil();
      }
    },
    processPupil() {
      // values
      this.pupil.name = this.name;
      this.pupil.gender = this.gender;
      this.pupil.year_id = this.yearId;

      if (this.selectedClass.id === 0) {
        this.pupil.inclass = this.classNew;
      } else {
        this.pupil.inclass = this.selectedClass.name;
      }

      let eal = this.hasEAL === true ? 1 : 0;
      this.pupil.english_second = eal;

      let premium = this.hasPupilPremium === true ? 1 : 0;
      this.pupil.premium_pupil = premium;

      this.pupil.looked_after = this.isLookedAfter
      this.pupil.vulnerable_pupil = this.isVulnerablePupil
      this.pupil.post_looked_after = this.isPostLookedAfter
      this.pupil.has_ehcp = this.hasECHP
      this.pupil.ethnicity = this.ethnicity;
      this.pupil.sen_status = this.sen;
      this.pupil.notes = this.notes
      this.pupil.tags = this.tags

      if (this.pupil.identifier === undefined) {

        SchoolService.create("pupils", this.pupil)
          .then((response) => this.completion(this.pupil.name + " added"))
          .catch((err) => {
            this.failure(err);
          });
      } else {

        SchoolService.update("pupils", this.pupil.identifier, this.pupil)
          .then((response) => this.completion(this.pupil.name + " updated"))
          .catch((err) => {
            this.failure(err);
          });
      }
    },
    completion(msg) {
      this.closeWindow()
    },
    failure(error) {
      this.$refs.saveNotice.failed();
      console.log("Pupil update error " + error);
    },
    classSelect(value) {
      this.selectedClass = value;
    },
    deletion() {
      this.$swal({
        title: "Are you sure you want to delete?",
        text: "You will not be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete!",
      }).then((result) => {
        if (result.value === true) {
          this.processDelete();
        }
      });
    },
    processDelete() {
      SchoolService.delete("pupils", this.pupil.identifier, null)
        .then((response) =>
          this.completion(this.pupil.name + " deleted from the system")
        )
        .catch((err) => {
          console.log(err);
        });
    },
    archive() {
      this.$swal({
        title: "Are you sure you want to archive?",
        text: "All pupil data will still be shown in reporting",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, archive!",
      }).then((result) => {
        if (result.value === true) {
          this.processArchive();
        }
      });
    },
    processArchive() {
      let payload = this.pupil;
      payload.is_archived = 1;
      SchoolService.update("pupils", this.pupil.identifier, payload)
        .then((response) => this.completion(this.pupil.name + " archived"))
        .catch((err) => {
          this.failure(err);
        });
    },
    closeWindow() {
      this.$router.push("/toolbox/pupils");

      window.scrollTo(0, 0);
    },
    addTags(value) {
      let seperator = this.tags.length > 0 ? " #" : "#"
      this.tags = this.tags + seperator + value
    },
  },
  components: {
    ClassDropdown,
    savenotice,
    innertopbar,

  },
};
</script>

<style scoped>
.row {
  margin-bottom: 11px;
}

input[type="radio"] {
  margin: 12px !important;
  width: 2em;
  height: 2em;
  cursor: pointer;
}
.right {
  float: right;
}

a.back {
  cursor: pointer !important;
}

.options section:hover {
  cursor: pointer;
}

.btn-important {
  background-color: #f4ab64 !important;
  background-image: none;
}

.buttons {
  padding-left: 0;
  margin-right: 14px;
}

.submit {
  box-shadow: none !important;
  width: 100%;
  height: 4em;
}

.view-middle.grey {
  background-color: #f6f7fb;
}

.view-middle .content.form {
  width: 100%;
}
</style>